import i18n from "config/i18next";

i18n.addResources("es", "picker", {
  profileTitle: "Datos del perfil",
  accountTitle: "Datos contables y bancarios",
  vehicleTitle: "Datos del vehículo",
  state: "Estado",
  approvePicker: "Aprobar picker",
  pickerFull: "picker full",
  approve: "Aprobar",
  revise: "Revisar datos",
  approvePickerTitle: "Aprobar picker",
  approvePickerMessage: "Al aprobar la solicitud, ya va a poder hacer envíos",
  dniFront: "Documento de identidad frente",
  dniBack: "Documento de identidad dorso",
  userFace: "Foto rostro",
  cbuCertificate: "Certificado bancario",
  cuitCertificate: "Constancia de CUIT",
  driverLicense: "Licencia de conducir",
  vehicleIdentificationBack: "Tarjeta dorso",
  vehicleIdentificationFront: "Tarjeta frente",
  driverInsuranceCard: "SOAT",
  approvedTitle: "Aprobación exitosa",
  approvedMessage: "Ya podés visualizar sus datos en la pestaña pickers",
  contactText: "¡Hola! {{name}}, ¿cómo estás?, nos comunicamos desde pickers",
  contactLabel: "Contactar",
  dirtyContactTitle: "Cambios sin guardar",
  dirtyContactText: "Los datos de contacto no se actualizaron correctamente",
  approveTooltip: `Antes de aprobar debes\nguardar los cambios `,
});

i18n.addResources("es_AR", "picker", {
  dniFront: "DNI frente",
  dniBack: "DNI dorso",
  cbuCertificate: "Comprobante de CBU",
  vehicleIdentificationBack: "Cédula dorso",
  vehicleIdentificationFront: "Cédula frente",
  driverInsuranceCard: "Seguro de automotor",
});

i18n.addResources("es_MX", "picker", {
  dniFront: "INE/IFE/FM3 frente",
  dniBack: "INE/IFE/FM3 dorso",
  cbuCertificate: "Certificado de titularidad bancaria",
  cuitCertificate: "Constancia de inscripción al RFC",
  vehicleIdentificationBack: "Tarjeta dorso",
  vehicleIdentificationFront: "Tarjeta frente",
  driverInsuranceCard: "Póliza de seguro vial",
});

i18n.addResources("es_CL", "picker", {
  dniFront: "RUN frente",
  dniBack: "RUN dorso",
  cbuCertificate: "Certificado de cuenta bancaria",
  criminalRecordCertificate: "Certificado de antecedentes",
  cuitCertificate: "Constancia de RUT",
  vehicleIdentificationBack: "Permiso de circulación dorso",
  vehicleIdentificationFront: "Permiso de circulación frente",
  driverInsuranceCard: "Seguro (SOAP)",
  infractionRecord: "Hoja de vida",
});
